module.exports = __webpack_public_path__ + "img/jira-logo.82759a25.png";